module.exports = __webpack_public_path__ + "img/pose-2.101674bc.png";